
const digest = '144801b71ec238cf811a1133552e10d81399a1928446030b26bf35906fbf1f9e';
const classes = {"item":"_item_1qtus_1","header":"_header_1qtus_9","title":"_title_1qtus_15","requisitions":"_requisitions_1qtus_23","requisition":"_requisition_1qtus_23"};
const css = `._item_1qtus_1 {
  font-family: Rubik, sans-serif;
  border: 1px solid #d1d4da;
  border-radius: 3px;
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}
._item_1qtus_1 ._header_1qtus_9 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  padding: 24px;
}
._item_1qtus_1 ._header_1qtus_9 ._title_1qtus_15 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #1665d8;
  font-size: 16px;
  font-weight: 500;
}
._item_1qtus_1 ._requisitions_1qtus_23 {
  display: flex;
  flex-direction: column;
  border-top: 1px solid #d1d4da;
  padding: 24px;
  gap: 10px;
}
._item_1qtus_1 ._requisitions_1qtus_23 ._requisition_1qtus_23 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  font-size: 14px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  